/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface PrefillPaymentRequest {
  documentType: "ЕНС" | "ОСС" | "НДФЛ" | "ПП ФЛ";
  ausnId?: string;

  /** @example 1234567890 */
  payerInn: string;

  /** @example 1234567890 */
  payerKpp?: string;

  /** @example ООО Рога и Копыта */
  receiverName: string;

  /** @example 9876543210 */
  receiverInn: string;

  /** @example 9876543210 */
  receiverKpp?: string;

  /** @example СЕВЕРО-ЗАПАДНЫЙ БАНК ПАО СБЕРБАНК */
  receiverBankName: string;

  /** @example 044030653 */
  receiverBankBIC: string;

  /** @example 30101810500000000653 */
  receiverBankCorAccount: string;

  /** @example 40702810255000035327 */
  receiverAccount: string;

  /** @example 01 */
  taxPayerStatus?: string;

  /** @example 0 */
  uip?: string;

  /**
   * Назначение платежа
   * @example Пополнение счёта ЕНС
   */
  purpose: string;

  /** @example 0 */
  kbk?: string;

  /** @example 0 */
  oktmo?: string;

  /** @example 0 */
  taxPaymentPurpose?: string;

  /** @example МС.04.2022 */
  taxPaymentPeriod?: string;

  /** @example 0456 */
  taxPaymentDocumentNumber?: string;

  /** @example 2023-03-17 */
  taxPaymentDocumentDate?: string;

  /** @example 0 */
  taxPaymentType?: string;

  /** @example 500 */
  amount?: string;
}

export interface PrefillPaymentsRequest {
  requestSite: PrefillPaymentRequest[];
}

export interface PrefillPaymentsIds {
  prefillPaymentId?: string[];
}

export interface ErrorMessage {
  /** Название ошибки */
  name?: string;

  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

/**
 * Информация о банке
 */
export interface PaymentBank {
  /**
   * Идентификатор банка
   * @format uuid
   */
  id?: string;

  /**
   * Наименование банка
   * @example Россельхозбанк
   */
  name: string;

  /** Тип населенного пункта */
  placetype: string;

  /** Наименование населенного пункта */
  placename: string;

  /**
   * БИК банка
   * @example 44030910
   */
  bic: string;

  /**
   * Кор. счет банка
   * @example 30101810900000000910
   */
  corAccount?: string;
  adress?: string;
  isResident?: boolean;
}

/**
 * Участник платежа
 */
export interface PaymentMember {
  /**
   * Идентификатор субъекта
   * @format uuid
   * @example c4b55aca-41b8-4708-9a36-dfc3090842d8
   */
  id: string;

  /**
   * Наименование субъекта
   * @example ООО Пример
   */
  name: string;

  /**
   * Номер счёта
   * @example 40702810935000001770
   */
  accountNumber: string;

  /**
   * ИНН
   * @example 7714698321
   */
  inn: string;

  /**
   * КПП
   * @example 771401001
   */
  kpp: string;

  /** Информация о банке */
  bank: PaymentBank;
}

/**
 * Подробная информация о платёжном документе по предзаполненным данным
 */
export interface PaymentResponse {
  /** Сумма операции */
  amount: number;

  /** Буквенный ISO-код валюты */
  currency: string;

  /** Способ отправки:     EMPTY           - Пусто     URGENT          - Срочно     ELECTRONICALLY  - Электронно     MAIL            - Почтой     TELEGRAPH       - Телеграфом */
  sendType: string;

  /**
   * Очередность
   * @format int32
   */
  priority: number;

  /** Участник платежа */
  payer: PaymentMember;

  /** Участник платежа */
  receiver: PaymentMember;

  /** Назначение платежа */
  ground: string;

  /** Признак налогового платежа */
  isTaxPayment: boolean;

  /** Статус отправителя */
  taxPayerStatus?: string;

  /** Код КБК */
  kbk?: string;

  /** Код ОКТМО */
  oktmo?: string;

  /** Код (УИН/УИП) */
  uin?: string;

  /** Основание налогового платежа */
  taxPaymentGround?: string;

  /** Налоговый период */
  taxPeriod?: string;

  /** Номер документа */
  taxDocNumber?: string;

  /** Дата документа */
  taxDocDate?: string;

  /** Код выплат */
  payType?: string;

  /** Код вида дохода */
  incomeCode?: string;

  /** Удержано по исполнительному документу */
  holdByExecDocSum?: number;

  /** Код валютной операции */
  curOperKindCode?: string;

  /** ИНН налогоплательщика (платеж за третье лицо) */
  innTaxPayer?: string;

  /** КПП налогоплательщика (платеж за третье лицо) */
  kppTaxPayer?: string;

  /** Наименование налогоплательщика (платеж за третье лицо) */
  taxPayerName?: string;

  /** Адрес налогоплательщика (платеж за третье лицо) */
  taxPayerAddress?: string;

  /** Идентификатор платежа в АУСН */
  ausnId?: string;

  /** Тип документа из АУСН */
  documentType?: "ЕНС" | "ОСС" | "НДФЛ" | "ПП ФЛ";

  /**
   * Идентификатор связанного ПП
   * @format uuid
   */
  linkedPrefill?: string;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис payments-adapter
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-rko-payment-adapter.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ <info@rshbintech.ru> (https://rshbintech.ru/)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Создания платёжных документов на основе данных из внешних систем
     * @name CreatePaymentPrefill
     * @summary Создание предзаполненных данных для платёжного документа
     * @request POST:/api/payment-adapter/v1/external/ausn/prefill
     * @secure
     */
    createPaymentPrefill: (
      data: PrefillPaymentsRequest,
      params: RequestParams = {}
    ) =>
      this.request<PrefillPaymentsIds, ErrorMessage>({
        path: `/api/payment-adapter/v1/external/ausn/prefill`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Создания платёжных документов на основе данных из внешних систем
     * @name GetPrefillPaymentById
     * @summary Получение предзаполненных данных для платёжного документа
     * @request GET:/api/payment-adapter/v1/external/ausn/prefill/{id}
     * @secure
     */
    getPrefillPaymentById: (id: string, params: RequestParams = {}) =>
      this.request<PaymentResponse, ErrorMessage>({
        path: `/api/payment-adapter/v1/external/ausn/prefill/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
